import { render, staticRenderFns } from "./SchemaDeleteModal.vue?vue&type=template&id=08b5d366&"
import script from "./SchemaDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SchemaDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports